// Fetch all projects
export const getProjects = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_ZVB_URL + "items/projects?fields=*.*");
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching projects:', error);
        throw error;
    }
};

export const getProjectDetails = async (projectName) => {
    try {
        const response = await fetch(process.env.REACT_APP_ZVB_URL + "items/projects/" + projectName +"?fields=*.*,assets.*&deep[assets][_sort]=sort");
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching projects:', error);
        throw error;
    }
};

export const getAlbumPhotos = async (albumName) => {
    try {
        const response = await fetch(process.env.REACT_APP_ZVB_URL + "items/albums/" + albumName +"?fields=*,photos.*&deep[photos][_limit]=300");
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching projects:', error);
        throw error;
    }
};